<template>
  <div />
</template>

<script>
import AbstractFormField from 'chimera/all/components/form/fields/AbstractFormField'
import usesLeadPost from 'chimera/all/mixins/usesLeadPost'

export const field = 'submit'
export default {
  name: 'LeadSubmitFormPart',

  extends: AbstractFormField,

  mixins: [usesLeadPost],

  props: {
    field: {
      type: String,
      default: field,
    },

    isApiValidated: {
      type: Boolean,
      default: false,
    },
  },

  /**
   * @returns {object}
   */
  data() {
    return {
      value: undefined,
    }
  },

  methods: {
    /**
     * LeadSubmitFormPart is not a real form field — it orchestrates lead posting.
     * Prevent the centralized value watcher from triggering reset/validation cycles.
     */
    onValueChange() {},

    /**
     * LeadSubmitFormPart should never store data in the lead store.
     * Its 'submit' key would leak into the lead POST payload and cause a 422.
     */
    setValueInStore() {},

    /**
     * No-op: nothing to unset since setValueInStore is a no-op.
     */
    unsetValueInStore() {},

    /**
     * @param {*} value
     */
    afterOnValidLeadPost(value) {
      this.value = true
      this.$emit('leadPostValid', value)
    },

    /**
     * @param {object} errorData
     */
    afterOnInvalidLeadPost(errorData) {
      this.value = false
      this.$emit('leadPostInvalid', errorData)
    },

    /**
     * @param {Error} error
     */
    afterOnErrorLeadPost(error) {
      this.$emit('leadPostError', error)
    },
  },
}
</script>
